<template>
    <div>
        <div class="[ c-off-canvas ] [ js-menu ]">
            <div class="[ c-off-canvas__header ]">
                <span
                    v-show="activeMenuIndex !== '-1'"
                    class="[ c-overlay__close-text ]"
                    @click="goBack"
                >
                    <i class="[ c-icon ] [ icon-arrow--left ]"></i>
                    {{ $translate('menu.return') }}
                </span>
                <i
                    class="[ c-off-canvas__close ] [ c-icon c-icon--large ] [ icon icon-close ] [ js-close-menu ]"
                    @click="resetActiveIndex"
                ></i>
            </div>
            <div class="[ c-off-canvas__nav ]">
                <ul
                    class="[ c-menu__list c-off-canvas__item ] [ pos--relative ] [ o-list-bare ] [ is-active ]"
                    :class="{ 'is-visible': activeMenuIndex === '-1' }"
                >
                    <li
                        v-for="(firstLevelItem, index) in navigationContent"
                        :key="index"
                        class="[ c-off-canvas__list-item ]"
                        @click="setActiveIndex(index)"
                    >
                        <span
                            class="[ c-off-canvas__menu-item ]"
                        >
                            <a
                                class="[ c-off-canvas__link ]"
                                :class="{ 'c-off-canvas__link--disabled' : hasSubTree(firstLevelItem.children) }"
                                :href="firstLevelItem.link"
                                :target="firstLevelItem.target"
                            >
                                {{ firstLevelItem.title }}
                            </a>
                            <span
                                v-if="hasSubTree(firstLevelItem.children)"
                                class="[ c-menu-expand ]"
                            ></span>
                        </span>
                        <ul
                            class="[ c-off-canvas__item ]  [ o-list-bare ]"
                            :class="{ 'is-active': activeMenuIndex === index.toString() || getPreviousLevel === index.toString(), 'is-visible': activeMenuIndex === index.toString() }"
                        >
                            <li
                                v-for="(secondLevelItem, secondLevelIndex) in firstLevelItem.children"
                                :key="index + '.' + secondLevelIndex"
                                class="[ c-off-canvas__list-item ]"
                                @click="setActiveIndex(index + '.' + secondLevelIndex)"
                            >
                                <span
                                    class="[ c-off-canvas__menu-item ]"
                                >
                                    <a
                                        class="[ c-off-canvas__link ]"
                                        :class="{ 'c-off-canvas__link--disabled' : hasSubTree(secondLevelItem.children) }"
                                        :href="secondLevelItem.link"
                                        :target="secondLevelItem.target"
                                    >
                                        {{ secondLevelItem.title }}
                                    </a>
                                    <span
                                        v-if="hasSubTree(secondLevelItem.children)"
                                        class="[ c-menu-expand ]"
                                    ></span>
                                </span>
                                <ul
                                    class="[ c-off-canvas__item ] [ o-list-bare ]"
                                    :class="{ 'is-active is-visible': activeMenuIndex === index + '.' + secondLevelIndex }"
                                >
                                    <li
                                        v-for="(thirdLevelItem, _) in secondLevelItem.children"
                                        :key="_"
                                        class="[ c-off-canvas__list-item ]"
                                    >
                                        <span
                                            class="[ c-off-canvas__menu-item ]"
                                        >
                                            <a
                                                class="[ c-off-canvas__link ]"
                                                :href="thirdLevelItem.link"
                                                :target="thirdLevelItem.target"
                                            >
                                                {{ thirdLevelItem.title }}
                                            </a>
                                        </span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
        <div
            class="[ c-off-canvas__backdrop ] [ js-close-menu ]"
            @click="resetActiveIndex"
        ></div>
    </div>
</template>

<script>
    import { mapTranslate } from '@store/i18n/getters'
    import store from '@store/index'

    export default {
        store,
        props: {
            menuData: {
                type: String,
                default: ''
            }
        },

        data () {
            return {
                activeMenuIndex: '-1',
                navigationContent: [],
                menuItemsAmount: 0
            }
        },

        computed: {
            ...mapTranslate(),
            getPreviousLevel () {
                const lastIndexOfPoint = this.activeMenuIndex.lastIndexOf('.');
                if (lastIndexOfPoint > -1) {
                    return this.activeMenuIndex.substring(0, lastIndexOfPoint);
                }

                return lastIndexOfPoint.toString();
            }
        },

        beforeMount () {
            this.navigationContent = JSON.parse(this.menuData) || [];
            this.activeMenuIndex = '-1'
        },

        methods: {
            setActiveIndex (index) {
                event.stopPropagation();
                this.activeMenuIndex = index.toString();
            },
            goBack () {
                this.activeMenuIndex = this.getPreviousLevel;
            },
            hasSubTree (subTree) {
                return subTree && subTree.length > 0;
            },
            resetActiveIndex () {
                this.activeMenuIndex = '-1';
            }
        }
    }
</script>
